import React from 'react';
import { FormattedMessage } from 'react-intl';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import { jsx as ___EmotionJSX } from "@emotion/react";
const NotFoundPage = () => {
  return ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX("h1", null, ___EmotionJSX(FormattedMessage, {
    id: 'pages.404.header'
  })), ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
    id: 'pages.404.content'
  })), ___EmotionJSX(Link, {
    to: "/"
  }, ___EmotionJSX(FormattedMessage, {
    id: 'pages.404.link'
  })), ___EmotionJSX(Spacer, null));
};
export default NotFoundPage;